import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyKBApprovalDetailPage = lazyWithRetry(
  () => import("./KBApprovalDetailPage"),
);

const KBApprovalDetailPage = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyKBApprovalDetailPage {...props} />;

export default KBApprovalDetailPage;
